import React from 'react';
import { Result, Button } from 'antd';

const TechnicalErrorPage: React.FC = () => {
    const handleBackHome = () => {
        window.location.href = '/login'; // Redirect to the home page
    };

    return (
        <Result
            status="500"
            title="500"
            subTitle="Sorry, something went wrong. Please try again later."
            extra={<Button type="primary" onClick={handleBackHome}>Back Home</Button>}
        />
    );
};

export default TechnicalErrorPage;
